import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Button from '../button';
export type PaginationProps = {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
  pageIndex: number;
  pageSize: number;
  totalNumResults?: number;
};
const Pagination = t0 => {
  const $ = _c(27);
  const {
    hasNextPage,
    hasPrevPage,
    onNextPage,
    onPrevPage,
    pageIndex,
    pageSize,
    totalNumResults
  } = t0;
  const lowerBoundShownResults = pageIndex * pageSize + 1;
  const pageUpperBound = (pageIndex + 1) * pageSize;
  const upperBoundShownResults = totalNumResults ? Math.min(pageUpperBound, totalNumResults) : pageUpperBound;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.pagination"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t1);
  let t2;
  if ($[1] !== hasNextPage || $[2] !== lowerBoundShownResults || $[3] !== t || $[4] !== totalNumResults || $[5] !== upperBoundShownResults) {
    t2 = totalNumResults ? t("showing", {
      lowerBoundShownResults,
      upperBoundShownResults,
      totalNumResults
    }) : t(hasNextPage ? "showing-no-count-next-page" : "showing-no-count", {
      lowerBoundShownResults,
      upperBoundShownResults
    });
    $[1] = hasNextPage;
    $[2] = lowerBoundShownResults;
    $[3] = t;
    $[4] = totalNumResults;
    $[5] = upperBoundShownResults;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const text = t2;
  if (hasNextPage || hasPrevPage) {
    let t3;
    if ($[7] !== text) {
      t3 = <div className="flex items-center"><div className="text-body-2 text-secondary">{text}</div></div>;
      $[7] = text;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    const t4 = !hasPrevPage;
    let t5;
    if ($[9] !== t) {
      t5 = t("previous");
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== onPrevPage || $[12] !== t4 || $[13] !== t5) {
      t6 = <Button disabled={t4} onClick={onPrevPage} variant="secondary">{t5}</Button>;
      $[11] = onPrevPage;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    const t7 = !hasNextPage;
    let t8;
    if ($[15] !== t) {
      t8 = t("next");
      $[15] = t;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== onNextPage || $[18] !== t7 || $[19] !== t8) {
      t9 = <Button disabled={t7} onClick={onNextPage} variant="secondary">{t8}</Button>;
      $[17] = onNextPage;
      $[18] = t7;
      $[19] = t8;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    let t10;
    if ($[21] !== t6 || $[22] !== t9) {
      t10 = <div className="flex gap-2 justify-end">{t6}{t9}</div>;
      $[21] = t6;
      $[22] = t9;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    let t11;
    if ($[24] !== t10 || $[25] !== t3) {
      t11 = <div className="flex justify-between mt-4">{t3}{t10}</div>;
      $[24] = t10;
      $[25] = t3;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    return t11;
  }
  return null;
};
export default Pagination;